import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { navigate } from 'gatsby-plugin-intl';
import { useTranslate } from 'react-polyglot';

import Config from '../../../config';
import MenuIcon from '../../icons/Menu';
import { withLocation } from '../../../utils/withLocation';

import './MobileHeaderMenu.scss';

const MobileHeaderMenu = () => {

  const t = useTranslate();

  const goTo = (destination) => {
    navigate(destination);
  };

  return (
    <div className="menu-item desktop-hide tablet-hide-landscape">
      <Dropdown
        text=""
        icon={<MenuIcon style={{ fontSize: '1rem', color: '#fff' }} className="icon" />}
        direction="left"
        floating
        labeled
        button
        className="dropdown icon btn-menu"
      >
        <Dropdown.Menu className="dropdown-menu">

          <Dropdown.Item text={t('common.toOffer')} onClick={() => goTo(Config.routePaths.pass)} className="desktop-hide lnk-offer" />

          <Dropdown.Item text={t('common.allClasses')} onClick={() => goTo(Config.routePaths.allClasses)} className="desktop-hide lnk-all-classes" />

          <Dropdown.Item text={t('common.payment.passTitle')} onClick={() => goTo(Config.routePaths.pass)} className="desktop-hide lnk-pass" />
          <Dropdown.Divider className="desktop-hide" />

          <Dropdown.Item text={t('common.signin')} onClick={() => goTo(Config.routePaths.signin)} className="lnk-signin" />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default withLocation(
  MobileHeaderMenu,
);
